module.exports = __webpack_public_path__ + "static/media/25 de moduri de a crește puterea creierului.6b939d60.png";